import { render } from "./ProductStatusSpanList.vue?vue&type=template&id=669777d9"
import script from "./ProductStatusSpanList.vue?vue&type=script&lang=js"
export * from "./ProductStatusSpanList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__